module.exports = __webpack_public_path__ + "static/media/PH3800__004_Strange.a1097eaf.mp3";